import { render, staticRenderFns } from "./WorkflowFormBuilderAccessPredicateQueryTreeBuilder.vue?vue&type=template&id=00bc94a8&"
import script from "./WorkflowFormBuilderAccessPredicateQueryTreeBuilder.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderAccessPredicateQueryTreeBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports